<template>
  <ul v-if="index === 1" class="mb-0 pl-3 font-weight-bold">
    <li>Gather your items</li>
    <li>Complete Fanatics Collect submission</li>
    <li>Ship it &amp; add your tracking</li>
  </ul>
  <p v-else-if="index === 2" class="mb-0 font-weight-bold">Fanatics Collect receives &amp; reviews submission</p>
  <p v-else-if="index === 3" class="mb-0 font-weight-bold">Fanatics Collect forwards to Authenticator</p>
  <p v-else-if="index === 4" class="mb-0 font-weight-bold">Returned to Fanatics Collect</p>
  <p v-else-if="index === 5" class="mb-0 font-weight-bold">Archived in Fanatics Collect Vault &amp; Ready for Sale</p>
</template>

<script>
export default {
  name: 'HowItWorksPopoverContents',
  props: {
    index: {
      type: Number,
      required: true
    }
  }
};
</script>
